import * as React from "react";
import { forwardRef } from "react";
const SvgAvatar = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 38 39", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "#FBFBFB", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M29.8 34.186a10.8 10.8 0 0 0-10.8-10.8m0 0a10.8 10.8 0 0 0-10.8 10.8m10.8-10.8a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4m18-3.6c0 9.941-8.059 18-18 18s-18-8.059-18-18 8.059-18 18-18 18 8.059 18 18" }));
const ForwardRef = forwardRef(SvgAvatar);
export { ForwardRef as ReactComponent };
